import React from 'react';
import Icon from '../../../components/AppIcon';


const TestimonialFilterPanel = ({ filters, onFilterChange, totalCount }) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({ [field]: value });
  };

  const handleClearFilters = () => {
    onFilterChange({
      departmentType: 'all',
      organizationSize: 'all',
      useCase: 'all',
      testimonialType: 'all',
      minRating: 0,
      searchTerm: ''
    });
  };

  const activeFilterCount = [
    filters?.departmentType !== 'all',
    filters?.organizationSize !== 'all',
    filters?.useCase !== 'all',
    filters?.testimonialType !== 'all',
    filters?.minRating > 0,
    filters?.searchTerm !== ''
  ]?.filter(Boolean)?.length;

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 sticky top-6">
      <div className="p-6 border-b border-gray-200 dark:border-slate-700">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Filter Testimonials</h2>
          {activeFilterCount > 0 && (
            <button
              onClick={handleClearFilters}
              className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
            >
              Clear ({activeFilterCount})
            </button>
          )}
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400">{totalCount} results</p>
      </div>
      <div className="p-6 space-y-6">
        {/* Search */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Search
          </label>
          <div className="relative">
            <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={filters?.searchTerm}
              onChange={(e) => handleFilterChange('searchTerm', e?.target?.value)}
              placeholder="Search testimonials..."
              className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-slate-700 dark:text-white text-sm"
            />
          </div>
        </div>

        {/* Department Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Department Type
          </label>
          <select
            value={filters?.departmentType}
            onChange={(e) => handleFilterChange('departmentType', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-slate-700 dark:text-white text-sm"
          >
            <option value="all">All Types</option>
            <option value="government">Government</option>
            <option value="provincial">Provincial</option>
            <option value="private">Private Sector</option>
          </select>
        </div>

        {/* Organization Size */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Organization Size
          </label>
          <select
            value={filters?.organizationSize}
            onChange={(e) => handleFilterChange('organizationSize', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-slate-700 dark:text-white text-sm"
          >
            <option value="all">All Sizes</option>
            <option value="small">Small (1-50)</option>
            <option value="medium">Medium (51-200)</option>
            <option value="large">Large (201+)</option>
          </select>
        </div>

        {/* Use Case */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Compliance Focus
          </label>
          <select
            value={filters?.useCase}
            onChange={(e) => handleFilterChange('useCase', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-slate-700 dark:text-white text-sm"
          >
            <option value="all">All Focus Areas</option>
            <option value="compliance">Compliance Management</option>
            <option value="payroll">Payroll Processing</option>
            <option value="workforce">Workforce Analytics</option>
            <option value="document">Document Management</option>
          </select>
        </div>

        {/* Testimonial Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Testimonial Type
          </label>
          <div className="space-y-2">
            {['all', 'written', 'video', 'photo']?.map((type) => (
              <label key={type} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="testimonialType"
                  value={type}
                  checked={filters?.testimonialType === type}
                  onChange={(e) => handleFilterChange('testimonialType', e?.target?.value)}
                  className="text-blue-600 focus:ring-blue-500"
                />
                <span className="text-sm text-gray-700 dark:text-gray-300 capitalize">{type}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Minimum Rating */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Minimum Rating
          </label>
          <div className="space-y-2">
            {[0, 3, 4, 5]?.map((rating) => (
              <label key={rating} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="minRating"
                  value={rating}
                  checked={filters?.minRating === rating}
                  onChange={(e) => handleFilterChange('minRating', parseInt(e?.target?.value))}
                  className="text-blue-600 focus:ring-blue-500"
                />
                <span className="text-sm text-gray-700 dark:text-gray-300">
                  {rating === 0 ? 'All Ratings' : `${rating}+ Stars`}
                </span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialFilterPanel;